// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-ed {
  --ed-bg: #0b0f19;
  --ed-text: #f8fafc;
  --ed-muted: #94a3b8;
  --ed-border: rgba(255, 255, 255, 0.08);
  --ed-card: rgba(15, 23, 42, 0.72);
  --ed-primary: var(--brand-primary, #0877bc);
  --ed-in: #34d399;
  --ed-out: #fb7185;
  --ed-call: #fbbf24;
  --ed-ease: cubic-bezier(0.16, 1, 0.3, 1);
  min-height: calc(100vh - 72px);
  padding-top: 1.25rem;
  padding-bottom: calc(6rem + env(safe-area-inset-bottom, 0px));
  padding-left: max(1.1rem, env(safe-area-inset-left, 0px));
  padding-right: max(1.1rem, env(safe-area-inset-right, 0px));
  color: var(--ed-text);
  font-family: Outfit, Poppins, Inter, sans-serif;
  width: 100%;
  max-width: min(1120px, 100%);
  margin-inline: auto;
  box-sizing: border-box;
  overflow-x: clip;
  background:
    radial-gradient(980px 460px at 6% -16%, color-mix(in srgb, var(--ed-primary) 28%, transparent), transparent 58%),
    radial-gradient(640px 280px at 108% 8%, rgba(251, 191, 36, 0.08), transparent 52%),
    transparent;
}

.comp-ed--light {
  --ed-bg: #f3f5f8;
  --ed-text: #0f172a;
  --ed-muted: #475569;
  --ed-border: rgba(15, 23, 42, 0.08);
  --ed-card: rgba(255, 255, 255, 0.86);
  --ed-in: #047857;
  --ed-out: #e11d48;
  --ed-call: #b45309;
}

.comp-ed__hero h1 {
  margin: 0.2rem 0 0;
  font-size: 1.85rem;
  letter-spacing: -0.04em;
  font-weight: 800;
}

.comp-ed__kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  color: var(--ed-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.comp-ed__lede {
  margin: 0.55rem 0 0;
  color: var(--ed-muted);
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 40rem;
}

.comp-ed__lead {
  margin: 0.75rem 0 0;
  padding: 0.7rem 0.9rem;
  border-radius: 14px;
  background: color-mix(in srgb, var(--ed-primary) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--ed-primary) 28%, transparent);
  font-size: 0.88rem;
  line-height: 1.45;
}

.comp-ed__tabs {
  position: sticky;
  top: 0;
  z-index: 4;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.3rem;
  margin: 1.15rem 0 1rem;
  padding: 0.28rem;
  border-radius: 16px;
  border: 1px solid var(--ed-border);
  background: color-mix(in srgb, var(--ed-card) 88%, transparent);
  backdrop-filter: blur(16px);
}

.comp-ed__tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 44px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--ed-muted);
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.25s var(--ed-ease), color 0.25s var(--ed-ease), transform 0.2s var(--ed-ease);
}

.comp-ed__tabs button em {
  font-style: normal;
  min-width: 1.2rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.68rem;
}

.comp-ed__tabs button.is-active {
  background: var(--ed-primary);
  color: #fff;
}

.comp-ed__tabs button:active {
  transform: scale(0.98);
}

.comp-ed__error {
  color: #fb7185;
  margin: 0 0 0.75rem;
}

.comp-ed__ok {
  color: #34d399;
  margin: 0 0 0.75rem;
}

.comp-ed__card {
  margin-bottom: 1rem;
  padding: 1.1rem 1rem;
  border-radius: 20px;
  border: 1px solid var(--ed-border);
  background: var(--ed-card);
  backdrop-filter: blur(16px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
}

.comp-ed__card h2 {
  margin: 0;
  font-size: 1.05rem;
  letter-spacing: -0.02em;
}

.comp-ed__hint {
  margin: 0.35rem 0 0;
  color: var(--ed-muted);
  font-size: 0.86rem;
  line-height: 1.5;
}

.comp-ed__stepper {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
}

.comp-ed__stepper strong {
  min-width: 2rem;
  text-align: center;
  font-size: 1.6rem;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.04em;
}

.comp-ed__stepper button {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  border: 1px solid var(--ed-border);
  background: color-mix(in srgb, var(--ed-primary) 12%, transparent);
  color: inherit;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform 0.2s var(--ed-ease);
}

.comp-ed__stepper button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.comp-ed__stepper button:not(:disabled):active {
  transform: scale(0.96);
}

.comp-ed__teams {
  display: grid;
  gap: 0.85rem;
}

.comp-ed__team {
  padding: 1rem;
  border-radius: 20px;
  border: 1px solid var(--ed-border);
  background: var(--ed-card);
  backdrop-filter: blur(16px);
}

.comp-ed__team header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.55rem;
}

.comp-ed__team h3 {
  margin: 0;
  font-size: 1rem;
}

.comp-ed__team header span,
.comp-ed__sub {
  color: var(--ed-muted);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.comp-ed__sub {
  margin: 1rem 0 0.4rem;
}

.comp-ed__team ul,
.comp-ed__people {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.comp-ed__team li,
.comp-ed__people li {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.55rem;
  min-height: 42px;
  min-width: 0;
}

.comp-ed__team li.is-empty,
.comp-ed__people li.is-empty {
  opacity: 0.7;
}

.comp-ed__ava {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.comp-ed__ava--ini {
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--ed-primary) 18%, transparent);
  color: var(--ed-primary);
  font-size: 0.72rem;
  font-weight: 700;
}

.comp-ed__who {
  min-width: 0;
  flex: 1 1;
}

.comp-ed__acts {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.35rem;
}

.comp-ed__who strong {
  display: block;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comp-ed__who em {
  display: block;
  font-style: normal;
  color: var(--ed-muted);
  font-size: 0.75rem;
}

.comp-ed__ghost,
.comp-ed__primary {
  flex-shrink: 0;
  min-height: 40px;
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  transition: transform 0.2s var(--ed-ease);
}

.comp-ed__ghost {
  border: 1px solid var(--ed-border);
  background: transparent;
  color: inherit;
}

.comp-ed__ghost:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--ed-out) 45%, var(--ed-border));
  color: var(--ed-out);
}

.comp-ed__primary {
  border: 0;
  background: var(--ed-primary);
  color: #fff;
}

.comp-ed__primary:hover:not(:disabled) {
  filter: brightness(1.06);
}

.comp-ed__badge {
  display: inline-flex;
  align-items: center;
  margin-top: 0.15rem;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ed-call);
}

.comp-ed__people li.is-called {
  border-radius: 12px;
  padding: 0.2rem 0.15rem;
  background: color-mix(in srgb, var(--ed-call) 10%, transparent);
}

.comp-ed__people li.is-out {
  border-radius: 12px;
  padding: 0.2rem 0.15rem;
  background: color-mix(in srgb, var(--ed-out) 10%, transparent);
}

.comp-ed__ghost:active,
.comp-ed__primary:active {
  transform: scale(0.97);
}

.comp-ed__ghost:disabled,
.comp-ed__primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.comp-ed__nextup {
  margin: 0.85rem 0 0;
  color: var(--ed-muted);
  font-size: 0.88rem;
}

.comp-ed__nextup strong {
  color: var(--ed-text);
}

.comp-ed__form {
  display: grid;
  gap: 0.75rem;
  margin-top: 0.85rem;
}

.comp-ed__form label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 650;
  color: var(--ed-muted);
}

.comp-ed__form input,
.comp-ed__form select {
  min-height: 44px;
  border-radius: 12px;
  border: 1px solid var(--ed-border);
  background: transparent;
  color: var(--ed-text);
  font: inherit;
  padding: 0.5rem 0.75rem;
}

.comp-ed__event {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
  padding: 0.95rem;
  border-radius: 18px;
  border: 1px solid var(--ed-border);
  background: var(--ed-card);
}

.comp-ed__event-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--ed-primary) 16%, transparent);
  color: var(--ed-primary);
}

.comp-ed__event em {
  display: block;
  margin-top: 0.2rem;
  font-style: normal;
  color: var(--ed-muted);
  font-size: 0.78rem;
}

.comp-ed__event .pill {
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ed-muted);
}

.comp-ed__tabs button:focus-visible,
.comp-ed__stepper button:focus-visible,
.comp-ed__ghost:focus-visible,
.comp-ed__primary:focus-visible {
  outline: 2px solid var(--ed-primary);
  outline-offset: 2px;
}

@media (max-width: 719px) {
  .comp-ed {
    padding-left: max(1.15rem, env(safe-area-inset-left, 0px));
    padding-right: max(1.15rem, env(safe-area-inset-right, 0px));
  }

  .comp-ed__form,
  .comp-ed__teams,
  .comp-ed__team,
  .comp-ed__next-list,
  .comp-ed__card {
    max-width: 100%;
    min-width: 0;
  }

  .comp-ed__tabs button {
    flex-direction: column;
    gap: 0.15rem;
    font-size: 0.68rem;
    padding: 0.35rem 0.15rem;
  }

  .comp-ed__team li,
  .comp-ed__people li {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.45rem;
    min-height: 40px;
    padding: 0.35rem 0;
    border-bottom: 1px solid var(--ed-border);
  }

  .comp-ed__team li:last-child,
  .comp-ed__people li:last-child {
    border-bottom: 0;
  }

  .comp-ed__who {
    flex: 1 1 auto;
    min-width: 0;
  }

  .comp-ed__ghost,
  .comp-ed__primary {
    flex: 0 0 auto;
    justify-self: auto;
    padding: 0.35rem 0.55rem;
    font-size: 0.72rem;
    white-space: nowrap;
  }
}

@media (min-width: 900px) {
  .comp-ed {
    padding-top: 1.75rem;
    padding-bottom: 5rem;
    padding-left: max(1.5rem, env(safe-area-inset-left, 0px));
    padding-right: max(1.5rem, env(safe-area-inset-right, 0px));
  }

  .comp-ed__hero h1 {
    font-size: 2.2rem;
  }

  .comp-ed__tabs {
    position: static;
    max-width: 560px;
  }

  .comp-ed__teams {
    grid-template-columns: 1fr 1fr;
  }

  .comp-ed__next-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    align-items: start;
  }

  .comp-ed__form {
    grid-template-columns: 1fr 1fr auto auto;
    align-items: end;
  }

  .comp-ed__ghost:hover:not(:disabled),
  .comp-ed__primary:hover:not(:disabled) {
    transform: scale(1.02);
  }
}

@media (prefers-reduced-motion: reduce) {
  .comp-ed *,
  .comp-ed *::before,
  .comp-ed *::after {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/CompetitionsPage.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,oBAAoB;EACpB,6DAA6D;EAC7D,yDAAyD;EACzD,2DAA2D;EAC3D,qBAAqB;EACrB,+CAA+C;EAC/C,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB;;;eAGa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kEAAkE;EAClE,wEAAwE;EACxE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,+DAA+D;EAC/D,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sGAAsG;AACxG;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kEAAkE;EAClE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kEAAkE;EAClE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qEAAqE;EACrE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;EAIE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,0DAA0D;IAC1D,4DAA4D;EAC9D;;EAEA;;;;;IAKE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;;IAEE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;IAEE,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,yDAAyD;IACzD,2DAA2D;EAC7D;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;EAC7B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap\");\n\n.comp-ed {\n  --ed-bg: #0b0f19;\n  --ed-text: #f8fafc;\n  --ed-muted: #94a3b8;\n  --ed-border: rgba(255, 255, 255, 0.08);\n  --ed-card: rgba(15, 23, 42, 0.72);\n  --ed-primary: var(--brand-primary, #0877bc);\n  --ed-in: #34d399;\n  --ed-out: #fb7185;\n  --ed-call: #fbbf24;\n  --ed-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  min-height: calc(100vh - 72px);\n  padding-top: 1.25rem;\n  padding-bottom: calc(6rem + env(safe-area-inset-bottom, 0px));\n  padding-left: max(1.1rem, env(safe-area-inset-left, 0px));\n  padding-right: max(1.1rem, env(safe-area-inset-right, 0px));\n  color: var(--ed-text);\n  font-family: Outfit, Poppins, Inter, sans-serif;\n  width: 100%;\n  max-width: min(1120px, 100%);\n  margin-inline: auto;\n  box-sizing: border-box;\n  overflow-x: clip;\n  background:\n    radial-gradient(980px 460px at 6% -16%, color-mix(in srgb, var(--ed-primary) 28%, transparent), transparent 58%),\n    radial-gradient(640px 280px at 108% 8%, rgba(251, 191, 36, 0.08), transparent 52%),\n    transparent;\n}\n\n.comp-ed--light {\n  --ed-bg: #f3f5f8;\n  --ed-text: #0f172a;\n  --ed-muted: #475569;\n  --ed-border: rgba(15, 23, 42, 0.08);\n  --ed-card: rgba(255, 255, 255, 0.86);\n  --ed-in: #047857;\n  --ed-out: #e11d48;\n  --ed-call: #b45309;\n}\n\n.comp-ed__hero h1 {\n  margin: 0.2rem 0 0;\n  font-size: 1.85rem;\n  letter-spacing: -0.04em;\n  font-weight: 800;\n}\n\n.comp-ed__kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  color: var(--ed-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.comp-ed__lede {\n  margin: 0.55rem 0 0;\n  color: var(--ed-muted);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  max-width: 40rem;\n}\n\n.comp-ed__lead {\n  margin: 0.75rem 0 0;\n  padding: 0.7rem 0.9rem;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--ed-primary) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--ed-primary) 28%, transparent);\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.comp-ed__tabs {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 0.3rem;\n  margin: 1.15rem 0 1rem;\n  padding: 0.28rem;\n  border-radius: 16px;\n  border: 1px solid var(--ed-border);\n  background: color-mix(in srgb, var(--ed-card) 88%, transparent);\n  backdrop-filter: blur(16px);\n}\n\n.comp-ed__tabs button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 44px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--ed-muted);\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.25s var(--ed-ease), color 0.25s var(--ed-ease), transform 0.2s var(--ed-ease);\n}\n\n.comp-ed__tabs button em {\n  font-style: normal;\n  min-width: 1.2rem;\n  padding: 0.05rem 0.35rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 0.68rem;\n}\n\n.comp-ed__tabs button.is-active {\n  background: var(--ed-primary);\n  color: #fff;\n}\n\n.comp-ed__tabs button:active {\n  transform: scale(0.98);\n}\n\n.comp-ed__error {\n  color: #fb7185;\n  margin: 0 0 0.75rem;\n}\n\n.comp-ed__ok {\n  color: #34d399;\n  margin: 0 0 0.75rem;\n}\n\n.comp-ed__card {\n  margin-bottom: 1rem;\n  padding: 1.1rem 1rem;\n  border-radius: 20px;\n  border: 1px solid var(--ed-border);\n  background: var(--ed-card);\n  backdrop-filter: blur(16px);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);\n}\n\n.comp-ed__card h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  letter-spacing: -0.02em;\n}\n\n.comp-ed__hint {\n  margin: 0.35rem 0 0;\n  color: var(--ed-muted);\n  font-size: 0.86rem;\n  line-height: 1.5;\n}\n\n.comp-ed__stepper {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.comp-ed__stepper strong {\n  min-width: 2rem;\n  text-align: center;\n  font-size: 1.6rem;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.04em;\n}\n\n.comp-ed__stepper button {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  border: 1px solid var(--ed-border);\n  background: color-mix(in srgb, var(--ed-primary) 12%, transparent);\n  color: inherit;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: transform 0.2s var(--ed-ease);\n}\n\n.comp-ed__stepper button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.comp-ed__stepper button:not(:disabled):active {\n  transform: scale(0.96);\n}\n\n.comp-ed__teams {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.comp-ed__team {\n  padding: 1rem;\n  border-radius: 20px;\n  border: 1px solid var(--ed-border);\n  background: var(--ed-card);\n  backdrop-filter: blur(16px);\n}\n\n.comp-ed__team header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 0.55rem;\n}\n\n.comp-ed__team h3 {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.comp-ed__team header span,\n.comp-ed__sub {\n  color: var(--ed-muted);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.comp-ed__sub {\n  margin: 1rem 0 0.4rem;\n}\n\n.comp-ed__team ul,\n.comp-ed__people {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.comp-ed__team li,\n.comp-ed__people li {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.55rem;\n  min-height: 42px;\n  min-width: 0;\n}\n\n.comp-ed__team li.is-empty,\n.comp-ed__people li.is-empty {\n  opacity: 0.7;\n}\n\n.comp-ed__ava {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.comp-ed__ava--ini {\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--ed-primary) 18%, transparent);\n  color: var(--ed-primary);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.comp-ed__who {\n  min-width: 0;\n  flex: 1;\n}\n\n.comp-ed__acts {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.comp-ed__who strong {\n  display: block;\n  font-size: 0.9rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.comp-ed__who em {\n  display: block;\n  font-style: normal;\n  color: var(--ed-muted);\n  font-size: 0.75rem;\n}\n\n.comp-ed__ghost,\n.comp-ed__primary {\n  flex-shrink: 0;\n  min-height: 40px;\n  border-radius: 999px;\n  padding: 0.35rem 0.75rem;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  transition: transform 0.2s var(--ed-ease);\n}\n\n.comp-ed__ghost {\n  border: 1px solid var(--ed-border);\n  background: transparent;\n  color: inherit;\n}\n\n.comp-ed__ghost:hover:not(:disabled) {\n  border-color: color-mix(in srgb, var(--ed-out) 45%, var(--ed-border));\n  color: var(--ed-out);\n}\n\n.comp-ed__primary {\n  border: 0;\n  background: var(--ed-primary);\n  color: #fff;\n}\n\n.comp-ed__primary:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\n.comp-ed__badge {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--ed-call);\n}\n\n.comp-ed__people li.is-called {\n  border-radius: 12px;\n  padding: 0.2rem 0.15rem;\n  background: color-mix(in srgb, var(--ed-call) 10%, transparent);\n}\n\n.comp-ed__people li.is-out {\n  border-radius: 12px;\n  padding: 0.2rem 0.15rem;\n  background: color-mix(in srgb, var(--ed-out) 10%, transparent);\n}\n\n.comp-ed__ghost:active,\n.comp-ed__primary:active {\n  transform: scale(0.97);\n}\n\n.comp-ed__ghost:disabled,\n.comp-ed__primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.comp-ed__nextup {\n  margin: 0.85rem 0 0;\n  color: var(--ed-muted);\n  font-size: 0.88rem;\n}\n\n.comp-ed__nextup strong {\n  color: var(--ed-text);\n}\n\n.comp-ed__form {\n  display: grid;\n  gap: 0.75rem;\n  margin-top: 0.85rem;\n}\n\n.comp-ed__form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.78rem;\n  font-weight: 650;\n  color: var(--ed-muted);\n}\n\n.comp-ed__form input,\n.comp-ed__form select {\n  min-height: 44px;\n  border-radius: 12px;\n  border: 1px solid var(--ed-border);\n  background: transparent;\n  color: var(--ed-text);\n  font: inherit;\n  padding: 0.5rem 0.75rem;\n}\n\n.comp-ed__event {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n  padding: 0.95rem;\n  border-radius: 18px;\n  border: 1px solid var(--ed-border);\n  background: var(--ed-card);\n}\n\n.comp-ed__event-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--ed-primary) 16%, transparent);\n  color: var(--ed-primary);\n}\n\n.comp-ed__event em {\n  display: block;\n  margin-top: 0.2rem;\n  font-style: normal;\n  color: var(--ed-muted);\n  font-size: 0.78rem;\n}\n\n.comp-ed__event .pill {\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ed-muted);\n}\n\n.comp-ed__tabs button:focus-visible,\n.comp-ed__stepper button:focus-visible,\n.comp-ed__ghost:focus-visible,\n.comp-ed__primary:focus-visible {\n  outline: 2px solid var(--ed-primary);\n  outline-offset: 2px;\n}\n\n@media (max-width: 719px) {\n  .comp-ed {\n    padding-left: max(1.15rem, env(safe-area-inset-left, 0px));\n    padding-right: max(1.15rem, env(safe-area-inset-right, 0px));\n  }\n\n  .comp-ed__form,\n  .comp-ed__teams,\n  .comp-ed__team,\n  .comp-ed__next-list,\n  .comp-ed__card {\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  .comp-ed__tabs button {\n    flex-direction: column;\n    gap: 0.15rem;\n    font-size: 0.68rem;\n    padding: 0.35rem 0.15rem;\n  }\n\n  .comp-ed__team li,\n  .comp-ed__people li {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 0.45rem;\n    min-height: 40px;\n    padding: 0.35rem 0;\n    border-bottom: 1px solid var(--ed-border);\n  }\n\n  .comp-ed__team li:last-child,\n  .comp-ed__people li:last-child {\n    border-bottom: 0;\n  }\n\n  .comp-ed__who {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .comp-ed__ghost,\n  .comp-ed__primary {\n    flex: 0 0 auto;\n    justify-self: auto;\n    padding: 0.35rem 0.55rem;\n    font-size: 0.72rem;\n    white-space: nowrap;\n  }\n}\n\n@media (min-width: 900px) {\n  .comp-ed {\n    padding-top: 1.75rem;\n    padding-bottom: 5rem;\n    padding-left: max(1.5rem, env(safe-area-inset-left, 0px));\n    padding-right: max(1.5rem, env(safe-area-inset-right, 0px));\n  }\n\n  .comp-ed__hero h1 {\n    font-size: 2.2rem;\n  }\n\n  .comp-ed__tabs {\n    position: static;\n    max-width: 560px;\n  }\n\n  .comp-ed__teams {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .comp-ed__next-list {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    align-items: start;\n  }\n\n  .comp-ed__form {\n    grid-template-columns: 1fr 1fr auto auto;\n    align-items: end;\n  }\n\n  .comp-ed__ghost:hover:not(:disabled),\n  .comp-ed__primary:hover:not(:disabled) {\n    transform: scale(1.02);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .comp-ed *,\n  .comp-ed *::before,\n  .comp-ed *::after {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
